import { useRequestContext } from '@coolblue-development/next-request-context/client';

import { routes } from './data/legacyRoutes';
import { RouteName } from './routes';

export const useClientUrl = (routeName: RouteName): string | undefined => {
  const { subsidiary, language } = useRequestContext();
  const route = routes[routeName]?.[subsidiary]?.[language];

  return route;
};
